/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Trial_End_Notification_TitleInputs */

const en_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Trial End Reminder`)
};

const ar_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تذكير بانتهاء الفترة التجريبية`)
};

const de_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erinnerung an das Versuchsende aktivieren`)
};

const es_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar el recordatorio de fin de prueba`)
};

const fr_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le rappel de fin d'essai`)
};

const it_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita promemoria fine prova`)
};

const ja_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアル終了リマインダーの有効化`)
};

const ko_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체험판 미리 알림 받기`)
};

const pt_br_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar lembrete de encerramento do teste grátis`)
};

const ru_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активировать напоминание об окончании пробной версии`)
};

const th_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดใช้งานการแจ้งเตือนการสิ้นสุดการทดลองใช้`)
};

const tr_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme Sonu Hatırlatıcısını Etkinleştir`)
};

const zh_cn_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开启试用结束提醒`)
};

const zh_tw_dialog_trial_end_notification_title = /** @type {(inputs: Dialog_Trial_End_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟試用結束提醒`)
};

/**
* | output |
* | --- |
* | "Enable Trial End Reminder" |
*
* @param {Dialog_Trial_End_Notification_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_trial_end_notification_title = /** @type {((inputs?: Dialog_Trial_End_Notification_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Trial_End_Notification_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_trial_end_notification_title(inputs)
	if (locale === "ar") return ar_dialog_trial_end_notification_title(inputs)
	if (locale === "de") return de_dialog_trial_end_notification_title(inputs)
	if (locale === "es") return es_dialog_trial_end_notification_title(inputs)
	if (locale === "fr") return fr_dialog_trial_end_notification_title(inputs)
	if (locale === "it") return it_dialog_trial_end_notification_title(inputs)
	if (locale === "ja") return ja_dialog_trial_end_notification_title(inputs)
	if (locale === "ko") return ko_dialog_trial_end_notification_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_trial_end_notification_title(inputs)
	if (locale === "ru") return ru_dialog_trial_end_notification_title(inputs)
	if (locale === "th") return th_dialog_trial_end_notification_title(inputs)
	if (locale === "tr") return tr_dialog_trial_end_notification_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_trial_end_notification_title(inputs)
	return zh_tw_dialog_trial_end_notification_title(inputs)
});